import { GetPresignedDownloadURLForQuestionOptionsTemplateRPC } from "@pulse/pulse-rpcs/lib/survey/getPresignedDownloadUrlForQuestionOptionsTemplateRPC";
import { GetPresignedDownloadURLForQuestionOptionsTemplateRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getPresignedDownloadUrlForQuestionOptionsTemplateRPCClientImpl";
import { AddSurveyQuestionRPC } from "@pulse/pulse-rpcs/lib/survey/addSurveyQuestionRPC";
import { AddSurveyQuestionRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/addSurveyQuestionRPCClientImpl";
import { CloseSurveyRPC } from "@pulse/pulse-rpcs/lib/survey/closeSurveyRPC";
import { CloseSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/closeSurveyRPCClientImpl";
import { DeleteQuestionRPC } from "@pulse/pulse-rpcs/lib/survey/deleteQuestionRPC";
import { DeleteQuestionRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/deleteQuestionRPCClientImpl";
import { GenerateSurveyPreviewLinkRPC } from "@pulse/pulse-rpcs/lib/survey/generateSurveyPreviewLinkRPC";
import { GenerateSurveyPreviewLinkRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/generateSurveyPreviewLinkRPCClientImpl";
import { GetAllTranslationsRPC } from "@pulse/pulse-rpcs/lib/survey/getAllTranslationsRPC";
import { GetAllTranslationsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getAllTranslationsRPCClientImpl";
import { GetPresignedDownloadURLForSurveyRulesRPC } from "@pulse/pulse-rpcs/lib/survey-rules/getPresignedDownloadUrlForSurveyRulesRPC";
import { GetPresignedDownloadURLForSurveyRulesRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/getPresignedDownloadUrlForSurveyRulesRPCClientImpl";
import { GetPresignedDownloadURLForSurveyRulesTemplateRPC } from "@pulse/pulse-rpcs/lib/survey-rules/getPresignedDownloadUrlForSurveyRulesTemplateRPC";
import { GetPresignedDownloadURLForSurveyRulesTemplateRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/getPresignedDownloadUrlForSurveyRulesTemplateRPCClientImpl";
import { GetPresignedDownloadURLForTranslationsRPC } from "@pulse/pulse-rpcs/lib/survey/getPresignedDownloadUrlForTranslationsRPC";
import { GetPresignedDownloadURLForTranslationsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getPresignedDownloadUrlForTranslationsRPCClientImpl";
import { GetPresignedUploadURLForClientLogoRPC } from "@pulse/pulse-rpcs/lib/survey/getPresignedUploadUrlForClientLogoRPC";
import { GetPresignedUploadURLForClientLogoRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getPresignedUploadUrlForClientLogoRPCClientImpl";
import { GetPresignedUploadURLForQuestionOptionsRPC } from "@pulse/pulse-rpcs/lib/survey/getPresignedUploadUrlForQuestionOptionsRPC";
import { GetPresignedUploadURLForQuestionOptionsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getPresignedUploadUrlForQuestionOptionsRPCClientImpl";
import { GetPresignedUploadURLForSurveyRulesRPC } from "@pulse/pulse-rpcs/lib/survey-rules/getPresignedUploadUrlForSurveyRulesRPC";
import { GetPresignedUploadURLForSurveyRulesRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/getPresignedUploadUrlForSurveyRulesRPCClientImpl";
import { GetPresignedUploadURLForTranslationsRPC } from "@pulse/pulse-rpcs/lib/survey/getPresignedUploadUrlForTranslationsRPC";
import { GetPresignedUploadURLForTranslationsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getPresignedUploadUrlForTranslationsRPCClientImpl";
import { GetProjectSurveyDetailsRPC } from "@pulse/pulse-rpcs/lib/project/getProjectSurveyDetailsRPC";
import { GetProjectSurveyDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/project/getProjectSurveyDetailsRPCClientImpl";
import { GetQuestionDetailsRPC } from "@pulse/pulse-rpcs/lib/survey/getQuestionDetailsRPC";
import { GetQuestionDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getQuestionDetailsRPCClientImpl";
import { GetQuestionsOfSurveyRPC } from "@pulse/pulse-rpcs/lib/survey/getQuestionsOfSurveyRPC";
import { GetQuestionsOfSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getQuestionsOfSurveyRPCClientImpl";
import { GetSurveySettingsRPC } from "@pulse/pulse-rpcs/lib/survey/getSurveySettingsRPC";
import { GetSurveySettingsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/getSurveySettingsRPCClientImpl";
import { ManageSurveyQuestionsRPC } from "@pulse/pulse-rpcs/lib/survey/manageSurveyQuestionsRPC";
import { ManageSurveyQuestionsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/manageSurveyQuestionsRPCClientImpl";
import { ReOpenSurveyRPC } from "@pulse/pulse-rpcs/lib/survey/reOpenSurveyRPC";
import { ReOpenSurveyRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/reOpenSurveyRPCClientImpl";
import { ResetClientLogoRPC } from "@pulse/pulse-rpcs/lib/survey/resetClientLogoRPC";
import { ResetClientLogoRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/resetClientLogoRPCClientImpl";
import { ResetSurveySettingsRPC } from "@pulse/pulse-rpcs/lib/survey/resetSurveySettingsRPC";
import { ResetSurveySettingsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/resetSurveySettingsRPCClientImpl";
import { UpdateSurveyQuestionRPC } from "@pulse/pulse-rpcs/lib/survey/updateSurveyQuestionRPC";
import { UpdateSurveyQuestionRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/updateSurveyQuestionRPCClientImpl";
import { UpdateSurveySettingsRPC } from "@pulse/pulse-rpcs/lib/survey/updateSurveySettingsRPC";
import { UpdateSurveySettingsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/updateSurveySettingsRPCClientImpl";
import { ValidateAndUploadSurveyRulesRPC } from "@pulse/pulse-rpcs/lib/survey-rules/validateAndUploadSurveyRulesRPC";
import { ValidateAndUploadSurveyRulesRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey-rules/validateAndUploadSurveyRulesRPCClientImpl";
import { ValidateAndUploadTranslationsRPC } from "@pulse/pulse-rpcs/lib/survey/validateAndUploadTranslationsRPC";
import { ValidateAndUploadTranslationsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/validateAndUploadTranslationsRPCClientImpl";
import { ValidateCSVAndUpdateQuestionOptionsRPC } from "@pulse/pulse-rpcs/lib/survey/validateCsvAndUpdateQuestionOptionsRPC";
import { ValidateCSVAndUpdateQuestionOptionsRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/validateCsvAndUpdateQuestionOptionsRPCClientImpl";
import { UpdateLanguageConfigurationRPC } from "@pulse/pulse-rpcs/lib/survey/updateLanguageConfigurationRPC";
import { UpdateLanguageConfigurationRPCClientImpl } from "@pulse/pulse-rpcs/lib/survey/updateLanguageConfigurationRPCClientImpl";
import { MockGetQuestionsOfSurveyClientImpl } from "./MockGetQuestionsOfSurvey";
import { MOCK } from "@pulse/shared-components";
import { MockGetQuestionDetailsClientImpl } from "./MockGetQuestionDetails";
import { MockAddSurveyQuestionClientImpl } from "./MockAddSurveyQuestion";
import { MockUpdateSurveyQuestionClientImpl } from "./MockUpdateSurveyQuestion";
import { MockGetPresignedDownloadURLForSurveyRulesTemplateClientImpl } from "./MockGetPresignedDownloadURLForSurveyRulesTemplate";
import { MockGetPresignedUploadURLForSurveyRulesClientImpl } from "./MockGetPresignedUploadURLForSurveyRulesRPC";
import { MockGetPresignedDownloadURLForSurveyRulesRPCClientImpl } from "./MockGetPresignedDownloadURLForSurveyRule";
import { MockValidateAndUploadSurveyRulesRPCClientImpl } from "./MockValidateAndUploadSurveyRulesRPCClientImpl";
import { MockGenerateSurveyPreviewLinkRPCClientImpl } from "./MockGenerateSurveyPreviewLinkRPCClientImpl";
import { MockDeleteQuestionClientImpl } from "./MockDeleteQuestion";
import { MockManageSurveyQuestionsRPCClientImpl } from "./MockMangeSurveyQuestionsRPCClientImpl";
import { MockGetProjectSurveyDetails } from "./MockGetProjectSurveyDetails";
import { MockGetSurveySettingsRPCClientImpl } from "./MockGetSurveySettingsRPCClientImpl";
import { MockUpdateSurveySettingsRPCClientImpl } from "./MockUpdateSurveySettingsRPCClientImpl";
import { MockCloseSurveyRPCClientImpl } from "./MockCloseSurveyRPCClientImpl";
import { MockReOpenSurveyRPCClientImpl } from "./MockReOpenSurveyRPCClientImpl";
import { MockGetPresignedUploadURLForClientLogoRPCClientImpl } from "./MockGetPresignedUploadURLForClientLogoRPCClientImpl";
import { MockResetClientLogoRPCClientImpl } from "./MockResetClientLogoRPCClientImpl";
import { MockResetSurveySettingsRPCClientImpl } from "./MockResetSurveySettingsRPCClientImpl";
import { MockGetPresignedDownloadURLForTranslationsRPCClientImpl } from "./MockGetPresignedDownloadURLForTranslationsRPCClient";
import { MockGetPresignedUploadURLForTranslationsRPCClientImpl } from "./MockGetPresignedUploadURLForTranslationsRPCClient";
import { MockValidateAndUploadTranslationsRPCClientImpl } from "./MockValidateAndUploadTranslationsRPCClient";
import { MockGetAllTranslationsRPCClientImpl } from "./MockGetAllTranslationsRPCClient";
import { MockGetPresignedDownloadURLForQuestionOptionsTemplateRPCClientImpl } from "./MockGetPresignedDownloadURLForQuestionOptionsTemplateRPCClientImpl";
import { MockValidateCSVAndUpdateQuestionOptionsRPCClientImpl } from "./MockValidateCSVAndUpdateQuestionOptionsRPCClientImpl";
import { MockGetPresignedUploadURLForQuestionOptionsRPCClientImpl } from "./MockGetPresignedUploadURLForQuestionOptionsRPCClientImpl";
import { MockUpdateLanguageConfigurationRPCClientImpl } from "./MockUpdateLanguageConfigurationRPCClientImpl";
import { APIClient } from "@surya-digital/tedwig";

export const useGetQuestionsOfSurveyRPCClientImpl = (
  apiClient: APIClient,
): GetQuestionsOfSurveyRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGetQuestionsOfSurveyClientImpl();
  } else {
    return new GetQuestionsOfSurveyRPCClientImpl(apiClient);
  }
};

export const useGetQuestionDetailsRPCClientImpl = (
  apiClient: APIClient,
): GetQuestionDetailsRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGetQuestionDetailsClientImpl();
  } else {
    return new GetQuestionDetailsRPCClientImpl(apiClient);
  }
};

export const useAddSurveyQuestionClientImpl = (
  apiClient: APIClient,
): AddSurveyQuestionRPC => {
  if (MOCK.surveyQuestions) {
    return new MockAddSurveyQuestionClientImpl();
  } else {
    return new AddSurveyQuestionRPCClientImpl(apiClient);
  }
};

export const useUpdateSurveyQuestionClientImpl = (
  apiClient: APIClient,
): UpdateSurveyQuestionRPC => {
  if (MOCK.surveyQuestions) {
    return new MockUpdateSurveyQuestionClientImpl();
  } else {
    return new UpdateSurveyQuestionRPCClientImpl(apiClient);
  }
};

export const useGetPresignedDownloadURLForSurveyRulesTemplateClientImpl = (
  apiClient: APIClient,
): GetPresignedDownloadURLForSurveyRulesTemplateRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGetPresignedDownloadURLForSurveyRulesTemplateClientImpl();
  } else {
    return new GetPresignedDownloadURLForSurveyRulesTemplateRPCClientImpl(
      apiClient,
    );
  }
};

export const useGetPresignedUploadURLForSurveyRulesClientImpl = (
  apiClient: APIClient,
): GetPresignedUploadURLForSurveyRulesRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGetPresignedUploadURLForSurveyRulesClientImpl();
  } else {
    return new GetPresignedUploadURLForSurveyRulesRPCClientImpl(apiClient);
  }
};

export const useGetPresignedDownloadURLForSurveyRulesClientImpl = (
  apiClient: APIClient,
): GetPresignedDownloadURLForSurveyRulesRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGetPresignedDownloadURLForSurveyRulesRPCClientImpl();
  } else {
    return new GetPresignedDownloadURLForSurveyRulesRPCClientImpl(apiClient);
  }
};

export const useValidateAndUploadSurveyRulesClientImpl = (
  apiClient: APIClient,
): ValidateAndUploadSurveyRulesRPC => {
  if (MOCK.surveyQuestions) {
    return new MockValidateAndUploadSurveyRulesRPCClientImpl();
  } else {
    return new ValidateAndUploadSurveyRulesRPCClientImpl(apiClient);
  }
};

export const useGenerateSurveyPreviewLinkClientImpl = (
  apiClient: APIClient,
): GenerateSurveyPreviewLinkRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGenerateSurveyPreviewLinkRPCClientImpl();
  } else {
    return new GenerateSurveyPreviewLinkRPCClientImpl(apiClient);
  }
};

export const useDeleteQuestionClientImpl = (
  apiClient: APIClient,
): DeleteQuestionRPC => {
  if (MOCK.surveyQuestions) {
    return new MockDeleteQuestionClientImpl();
  } else {
    return new DeleteQuestionRPCClientImpl(apiClient);
  }
};

export const useManageSurveyQuestionsRPCClientImpl = (
  apiClient: APIClient,
): ManageSurveyQuestionsRPC => {
  if (MOCK.surveyQuestions) {
    return new MockManageSurveyQuestionsRPCClientImpl();
  } else {
    return new ManageSurveyQuestionsRPCClientImpl(apiClient);
  }
};

export const useGetProjectSurveyDetailsClientImpl = (
  apiClient: APIClient,
): GetProjectSurveyDetailsRPC => {
  if (MOCK.surveyDetails) {
    return new MockGetProjectSurveyDetails();
  } else {
    return new GetProjectSurveyDetailsRPCClientImpl(apiClient);
  }
};

export const useGetSurveySettingsClientImpl = (
  apiClient: APIClient,
): GetSurveySettingsRPC => {
  if (MOCK.surveySettings) {
    return new MockGetSurveySettingsRPCClientImpl();
  }
  return new GetSurveySettingsRPCClientImpl(apiClient);
};

export const useUpdateSurveySettingsClientImpl = (
  apiClient: APIClient,
): UpdateSurveySettingsRPC => {
  if (MOCK.surveySettings) {
    return new MockUpdateSurveySettingsRPCClientImpl();
  }
  return new UpdateSurveySettingsRPCClientImpl(apiClient);
};

export const useCloseSurveyClientImpl = (
  apiClient: APIClient,
): CloseSurveyRPC => {
  if (MOCK.surveySettings) {
    return new MockCloseSurveyRPCClientImpl();
  }
  return new CloseSurveyRPCClientImpl(apiClient);
};

export const useReOpenSurveyClientImpl = (
  apiClient: APIClient,
): ReOpenSurveyRPC => {
  if (MOCK.surveySettings) {
    return new MockReOpenSurveyRPCClientImpl();
  }
  return new ReOpenSurveyRPCClientImpl(apiClient);
};

export const useGetPresignedUploadURLForClientLogoRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedUploadURLForClientLogoRPC => {
  if (MOCK.surveySettings) {
    return new MockGetPresignedUploadURLForClientLogoRPCClientImpl();
  }
  return new GetPresignedUploadURLForClientLogoRPCClientImpl(apiClient);
};

export const useResetClientLogoRPCClientImpl = (
  apiClient: APIClient,
): ResetClientLogoRPC => {
  if (MOCK.surveySettings) {
    return new MockResetClientLogoRPCClientImpl();
  }
  return new ResetClientLogoRPCClientImpl(apiClient);
};

export const useResetSurveySettingsRPCClientImpl = (
  apiClient: APIClient,
): ResetSurveySettingsRPC => {
  if (MOCK.surveySettings) {
    return new MockResetSurveySettingsRPCClientImpl();
  }
  return new ResetSurveySettingsRPCClientImpl(apiClient);
};

export const useGetPresignedDownloadURLForTranslationsRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedDownloadURLForTranslationsRPC => {
  if (MOCK.surveyTranslations) {
    return new MockGetPresignedDownloadURLForTranslationsRPCClientImpl();
  }
  return new GetPresignedDownloadURLForTranslationsRPCClientImpl(apiClient);
};

export const useGetPresignedUploadURLForTranslationsRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedUploadURLForTranslationsRPC => {
  if (MOCK.surveyTranslations) {
    return new MockGetPresignedUploadURLForTranslationsRPCClientImpl();
  }
  return new GetPresignedUploadURLForTranslationsRPCClientImpl(apiClient);
};

export const useValidateAndUploadTranslationsRPCClientImpl = (
  apiClient: APIClient,
): ValidateAndUploadTranslationsRPC => {
  if (MOCK.surveyTranslations) {
    return new MockValidateAndUploadTranslationsRPCClientImpl();
  }
  return new ValidateAndUploadTranslationsRPCClientImpl(apiClient);
};

export const useGetAllTranslationsRPCClientImpl = (
  apiClient: APIClient,
): GetAllTranslationsRPC => {
  if (MOCK.surveyTranslations) {
    return new MockGetAllTranslationsRPCClientImpl();
  }
  return new GetAllTranslationsRPCClientImpl(apiClient);
};

export const useGetPresignedDownloadURLForQuestionOptionsTemplateRPCClient = (
  apiClient: APIClient,
): GetPresignedDownloadURLForQuestionOptionsTemplateRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGetPresignedDownloadURLForQuestionOptionsTemplateRPCClientImpl();
  }
  return new GetPresignedDownloadURLForQuestionOptionsTemplateRPCClientImpl(
    apiClient,
  );
};

export const useValidateCSVAndUpdateQuestionOptionsRPCClient = (
  apiClient: APIClient,
): ValidateCSVAndUpdateQuestionOptionsRPC => {
  if (MOCK.surveyQuestions) {
    return new MockValidateCSVAndUpdateQuestionOptionsRPCClientImpl();
  }
  return new ValidateCSVAndUpdateQuestionOptionsRPCClientImpl(apiClient);
};

export const useGetPresignedUploadURLForQuestionOptionsRPCClientImpl = (
  apiClient: APIClient,
): GetPresignedUploadURLForQuestionOptionsRPC => {
  if (MOCK.surveyQuestions) {
    return new MockGetPresignedUploadURLForQuestionOptionsRPCClientImpl();
  }
  return new GetPresignedUploadURLForQuestionOptionsRPCClientImpl(apiClient);
};

export const useUpdateLanguageConfigurationRPCClientImpl = (
  apiClient: APIClient,
): UpdateLanguageConfigurationRPC => {
  if (MOCK.surveyTranslations) {
    return new MockUpdateLanguageConfigurationRPCClientImpl();
  }
  return new UpdateLanguageConfigurationRPCClientImpl(apiClient);
};
